export default __webpack_public_path__ + "static/media/how tipe.71805eaa.png";